import Footer from "../Navbar/Footer";


export const Career = () => {
  return (
  
    <div id="Career" className="">
   <section class="pt-24 pb-32 overflow-hidden">
  <div class="container mx-auto px-4">
    <h2 class="mb-20 font-heading font-bold text-6xl sm:text-8xl xl:text-10xl text-gray-900">Available positions</h2>
    <p class="mb-7 font-heading font-medium text-xl sm:text-2xl text-gray-900">No Vacancy Available</p>
    <div class="flex flex-wrap -m-3 mb-12">
    </div>
  </div>
</section>
   <Footer/>
    </div>
  );
};

export default Career;

